import React, { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { FieldItem, FIELD_TYPES } from '../../widgets/fields'
import { CustomButton, showToaster, toasterTypes } from '../../widgets';
import ModalPopup from '../../widgets/modal';
import _, { cloneDeep } from 'lodash';
import { DownloadOutlined, CopyOutlined } from '@ant-design/icons';
import { convertToIST, convertUTCTimeToIST } from '../../utils/ConvertUTCToLocale';
import { copyData } from '../../utils/Utils';
import { environment } from '../../environments/environment';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from '../../store/slices/auth';
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { getFilePreviewData, getVarConfig, saveVarConfig } from './apiController';
import { getRecord } from './apiController';
import ModalComponent from '../common/Modal/modal';
import { setIsLoading } from '../../store/slices/chatSlice';
import ReactMarkdown from 'react-markdown';

export default function ViewForm(props) {
    const [isModify, setisModify] = useState(false);
    const [isPartialModify, SetisPartialModify] = useState(false);
    const [action, setAction] = useState("");
    const [showOcrSplit, setShowOcrSplit] = useState(false);
    const [showSttSplit, setShowSttSplit] = useState(false);
    const projectDataPerm = useSelector(authSelector)
    const [permissionData, setPermissionData] = useState<any>([]);
    const [layout, setLayout] = useState<any>([]);
    const [currentBreakpoint, setCurrentBreakpoint] = useState('lg');
    const [layoutFin, setLayoutFin] = useState<any>([]);
    const [recordData, setRecordData] = useState<any>([]);
    const [recordDataFields, setRecordDataFields] = useState<any>([]);
    const [previewFileData, setPreviewFileData] = useState<string>(``);
    const [ocrOutput, setOcrOutput] = useState<string>(``);
    const [ocrFileDetails, setOcrFileDetails] = useState<any>(null);
    const [sttOutput, setSttOutput] = useState<any>(null);
    const [sttFileDetails, setSttFileDetails] = useState<any>(null);

    const gridFields = ["radioButtonGrid", "checkBoxGrid", "textBoxGrid"];

    const dispatch = useDispatch();

    useEffect(() => {
        if (props.isPreview) {
            setRecordDataFields(props.variables);
        } else {
            getRecordData();
        }

        let perData = projectDataPerm.projectPermissionData?.filter(itm => itm.projectId == props.projectData.id)
        let permArray = {};
        perData && perData[0]?.permissionData.forEach((obj) => {
            if (Object.keys(obj)[0] == "Data") {
                obj[Object.keys(obj)[0]].forEach((objItem) => {
                    permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected
                })
            } else if (Object.keys(obj)[0] == "Forms") {
                obj[Object.keys(obj)[0]].forEach((objItem) => {
                    permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected
                })
            }
        })
        setPermissionData(permArray)
    }, [])

    /**
     * get specific record data
     */
    async function getRecordData() {
        try {
            const response = await getRecord(props.selectedRecord.id, props.selectedRecord.version_id);
            if (response.data[0]?.ocr_output) {
                setOcrOutput(response.data[0].ocr_output);
            }
            if (response.data[0]?.ocr_file) {
                setOcrFileDetails(response.data[0].ocr_file);
            }
            if (response.data[0]?.stt_output) {
                setSttOutput(response.data[0].stt_output);
            }
            if (response.data[0]?.stt_file) {
                setSttFileDetails(response.data[0].stt_file);
            }
            let temp: any = _.groupBy(response.data[0].fields, "field_category");
            if (temp.empty) {
                let data = cloneDeep(temp.empty);
                delete temp.empty;
                temp.empty = data;
            }
            setRecordDataFields(temp);
            setRecordData(response.data)
            fetchConfig(temp);
        } catch (error) {
            console.log(error)
        }
    }

    function getRecordDataVarConfig() {
        const records = Object.keys(props.variables || {}).flatMap(obj =>
            props.variables[obj]
                .filter(subObj =>
                    subObj.field_type === "radioButtonGrid" ||
                    subObj.field_type === "checkBoxGrid" ||
                    subObj.field_type === "textBoxGrid"
                )
        );

        setRecordDataFields(records);
    }

    function getValues(data) {
        let valuesData: any = [];
        data.forEach(element => {
            valuesData.push({
                label: element,
                value: element
            });
        });
        return valuesData;
    }

    const sendReviewApprove = (type) => {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let fieldsArray: Array<object> = [];
        Object.keys(props.variables || {}).map((obj, index) => {
            props.variables[obj].map((subObj, subIndex) => {
                if (subObj.field_type === "dropDown" ||
                    subObj.field_type === "dropDownPreviousResponses") {
                    fieldsArray.push({
                        "id": subObj.id,
                        "field_selected_value": subObj?.selectedValue.label
                    })
                } else {
                    fieldsArray.push({
                        "id": subObj.id,
                        "field_selected_value": subObj?.selectedValue
                    })
                }

            })
        })


        let Obj = {
            "form_id": props.selectedRecord.form_id,
            "version_id": props.selectedRecord.version_id,
            "start_time": props.selectedRecord.start_time,
            "end_time": props.selectedRecord.end_time,
            "fields": fieldsArray,
            "update_remarks": "",
            "time_zone": tz,
            "id": props.selectedRecord.id
        };

        props.actions(type, Obj)
        setAction("")
    }

    /**
        * fetch form config data
        */
    const fetchConfig = async (data) => {
        try {
            let response = await getVarConfig(props.formData.id);
            let lay: any = [];
            Object.keys(data || {}).map((obj, index) => {
                lay.push(data[obj].map((subObj, subIndex) => {
                    let varSize = response.data && response.data.filter(flt =>
                        flt['var_id'] == subObj.id
                    )
                    if (varSize) {

                        return {
                            c: obj,
                            i: subObj.id,
                            x: parseInt(varSize[0]?.var_x) || subIndex % 2,
                            y: parseInt(varSize[0]?.var_y) || Math.floor(subIndex / 2),
                            w: varSize[0]?.var_size,
                            h: parseInt(varSize[0]?.var_h) || 1
                        }
                    } else {
                        return {
                            c: obj,
                            i: subObj.id,
                            x: subIndex % 2,
                            y: Math.floor(subIndex / 2),
                            w: 4,
                            h: 1
                        }
                    }
                }))
            })
            setLayout(lay)
        } catch (error) {

        }
    }

    const handleLayoutChange = (layoutdata, layouts) => {
        let indexLayout = layout.findIndex(item => item[0]['i'] == layoutdata[0]['i'])
        layout.splice(indexLayout, 1, layoutdata)
        setLayoutFin(layout)

    }

    /**
     * save config
     */
    const SaveConfig = async () => {
        let finalArray: any = []
        layoutFin.map(item => {
            item.map(itm => {
                let obj = {
                    var_id: itm.i,
                    var_size: itm.w,
                    var_x: itm.x,
                    var_y: itm.y,
                    var_h: itm.h
                }
                finalArray.push(obj)
            })
        })
        try {
            let response = await saveVarConfig(props.formData.id, finalArray)
            if (response) {
                showToaster(toasterTypes.SUCCESS, "Configurations saved")
            }
        } catch (error) {
            console.log(error)
        }
    }

    const gridRef = useRef<HTMLDivElement | null>(null);

    const getRowHeight = (): number => {
        if (!gridRef.current) return 100;
        return gridRef.current.offsetHeight / (layout.length / 2);
    };

    const [rowHeight, setRowHeight] = useState<number>(getRowHeight());

    useEffect(() => {
        const handleResize = () => setRowHeight(getRowHeight());
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [layout]);

    const recordDataIndex = layout.length;

    const getPreviewFileData = async () => {
        try {
            dispatch(setIsLoading(true));
            setAction("previewFileData");
            const response = await getFilePreviewData(props?.selectedRecord?.id);
            if (response) {
                showToaster(toasterTypes.SUCCESS, "Preview File Data fetched successfully")
                setAction("previewFileData");
                setPreviewFileData(response?.data?.extracted_output);
            }
        } catch (error) {
            console.log(error);
            showToaster(toasterTypes.ERROR, error?.message || "Failed to Fetch File Data");
        } finally {
            dispatch(setIsLoading(false));
        }
    }

    const toggleOcrSplit = () => {
        if (showSttSplit) {
            setShowSttSplit(false);
        }
        setShowOcrSplit(!showOcrSplit);
    }

    const toggleSttSplit = () => {
        if (showOcrSplit) {
            setShowOcrSplit(false);
        }
        setShowSttSplit(!showSttSplit);
    }

    const copyFullTranscript = () => {
        if (sttOutput?.full_transcript) {
            copyData(sttOutput.full_transcript, false);
        }
    }

    const copyConversation = () => {
        if (sttOutput?.conversation && sttOutput.conversation.length > 0) {
            const conversationText = sttOutput.conversation.join('\n');
            copyData(conversationText, false);
        }
    }

    const renderFormContent = () => (
        <div className='form-scroll'>
            {Object.keys(recordDataFields || {}).map((obj, index) => (
                <div key={index} >

                    <div className='category-container'>
                        <div className='category-text'>{obj !== 'undefined' ? obj : ''}</div>
                    </div>
                    <div>
                        <div ref={gridRef}>
                            <GridLayout
                                className="layout"
                                layout={layout[index]}
                                cols={4}
                                rowHeight={200}
                                width={(showOcrSplit || showSttSplit) && window.innerWidth > 700 ? (window.innerWidth / 2) - 100 : window.innerWidth - (window.innerWidth > 700 ? 100 : 40)}
                                onBreakpointChange={setCurrentBreakpoint}
                                onLayoutChange={handleLayoutChange}
                                isDraggable={props.isPreview ? true : false}
                                isResizable={props.isPreview ? true : false}>
                                {recordDataFields[obj]?.map((subObj, subIndex) => (
                                    !subObj.is_time_series && !subObj.grid_grp_id && <div key={subObj.id}><div>
                                        <FieldItem
                                            name={subObj.id}
                                            placeholder={(subObj.field_type === 'number' || subObj.field_type === 'textBox' || subObj.field_type === 'textArea') ? 'Enter' : 'Select'}
                                            label={subObj.field_name}
                                            type={(subObj.field_type === 'fileUpload' || subObj.field_type === 'fileUploadOCR') ? FIELD_TYPES.TEXT : subObj.field_type === 'dateField' ? FIELD_TYPES.TEXT : subObj.field_type === 'dropDown' ? FIELD_TYPES.DROP_DOWN : subObj.field_type === 'boolean' ? FIELD_TYPES.BOOLEAN : subObj.field_type === 'radioButton' ? FIELD_TYPES.RADIO_BUTTON : subObj.field_type === 'checkBox' ? FIELD_TYPES.CHECK_BOX : subObj.field_type === 'textArea' ? FIELD_TYPES.TEXT_AREA : subObj.field_type === 'signatureCapture' ? FIELD_TYPES.SIGNATURE_CAPTURE : subObj.field_type === 'imageCapture' ? FIELD_TYPES.IMAGE_CAPTURE : subObj.field_type === 'videoCapture' ? FIELD_TYPES.VIDEO_CAPTURE : subObj.field_type === 'audioCapture' ? FIELD_TYPES.AUDIO_CAPTURE : subObj.field_type === 'radioButtonGrid' ? FIELD_TYPES.RADIO_BUTTON_GRID : subObj.field_type === 'checkBoxGrid' ? FIELD_TYPES.CHECK_BOX_GRID : subObj.field_type === 'textBoxGrid' ? FIELD_TYPES.TEXT_BOX_GRID : subObj.field_type === 'password' ? FIELD_TYPES.PASSWORD : FIELD_TYPES.TEXT}
                                            value={
                                                props.isPreview
                                                    ? ''
                                                    : subObj.field_type === "dateTime"
                                                        ? convertToIST(subObj.field_selected_value, false)
                                                        : subObj.field_type === "dateField"
                                                            ? convertToIST(subObj.field_selected_value, true)
                                                            : subObj.field_type === "time"
                                                                ? convertUTCTimeToIST(subObj.field_selected_value) : subObj.field_type === "dropDown"
                                                                    ? { label: subObj.field_selected_value, value: subObj.field_selected_value }
                                                                    : subObj.field_selected_value
                                            }

                                            values={gridFields.includes(subObj.field_type) ? subObj.field_value : getValues(subObj.field_value || [])}
                                            rowValues={gridFields.includes(subObj.field_type) ? subObj.field_row_value : []}
                                            isListed={true}
                                            isDisabled={true}
                                            isPreview={(subObj.field_type === 'signatureCapture' || subObj.field_type === 'imageCapture' || subObj.field_type === 'audioCapture' || subObj.field_type === 'videoCapture' || subObj.field_type === 'password') ? true : false}
                                        />
                                        {subObj.field_type === "fileUploadOCR" &&
                                            <CustomButton
                                                type="primary"
                                                text="Preview"
                                                onClick={getPreviewFileData}
                                            />
                                        }

                                    </div>

                                    </div>
                                ))}
                            </GridLayout>
                        </div>
                        <GridLayout
                            className="layout"
                            layout={layout[index]}
                            cols={4}
                            rowHeight={150}
                            width={(showOcrSplit || showSttSplit) && window.innerWidth > 700 ? (window.innerWidth / 2) - 100 : window.innerWidth - (window.innerWidth > 700 ? 100 : 40)}
                            onBreakpointChange={setCurrentBreakpoint}
                            onLayoutChange={handleLayoutChange}
                            isDraggable={props.isPreview ? true : false}
                            isResizable={props.isPreview ? true : false}>
                            {recordDataFields[obj]?.map((subObj, subIndex) => (
                                subObj.is_time_series && <div key={subIndex}>
                                    <FieldItem
                                        name={subObj.id}
                                        placeholder={(subObj.field_type === 'number' || subObj.field_type === 'number' || subObj.field_type === 'textArea') ? 'Enter' : 'Select'}
                                        label={subObj.field_name}
                                        labelIcon="icon-loop"
                                        type={subObj.field_type === 'dateField' ? FIELD_TYPES.DATE_PICKER : subObj.field_type === 'dropDown' ? FIELD_TYPES.DROP_DOWN : subObj.field_type === 'boolean' ? FIELD_TYPES.BOOLEAN : subObj.field_type === 'radioButton' ? FIELD_TYPES.RADIO_BUTTON : subObj.field_type === 'checkBox' ? FIELD_TYPES.CHECK_BOX : subObj.field_type === 'textArea' ? FIELD_TYPES.TEXT_AREA : subObj.field_type === 'password' ? FIELD_TYPES.PASSWORD : FIELD_TYPES.TEXT}
                                        value={
                                            props.isPreview
                                                ? ''
                                                : subObj.field_type === "dateTime"
                                                    ? convertToIST(subObj.field_selected_value, false)
                                                    : subObj.field_type === "dateField"
                                                        ? convertToIST(subObj.field_selected_value, true)
                                                        : subObj.field_type === "time"
                                                            ? convertUTCTimeToIST(subObj.field_selected_value) : subObj.field_type === 'dropDown'
                                                                ? { label: subObj.field_selected_value, value: subObj.field_selected_value }
                                                                : subObj.field_selected_value
                                        }
                                        values={getValues(subObj.field_value || [])}
                                        isListed={true}
                                        isDisabled={true}
                                        isPreview={(subObj.field_type === 'signatureCapture' || subObj.field_type === 'imageCapture' || subObj.field_type === 'audioCapture' || subObj.field_type === 'videoCapture' || subObj.field_type === 'password') ? true : false}
                                    />
                                    {subObj.field_type === "fileUploadOCR" &&
                                        <CustomButton
                                            type="primary"
                                            text="Preview"
                                            onClick={getPreviewFileData}
                                        />
                                    }

                                </div>
                            ))}
                        </GridLayout>
                    </div>
                </div>
            ))}
        </div>
    );

    return (
        <div className={window.innerWidth > 700 ? 'view-form' : 'view-form-mobile'}>
            {isModify && (
                <ModalPopup
                    modalType="delete"
                    modalText="Modify will allow you to modify previously entered data also."
                    actionText="Do you want continue modifying?"
                    closeModal={() => setisModify(false)}
                    onAction={() => props.modify(recordData[0])}
                />
            )}

            {isPartialModify && (
                <ModalPopup
                    modalType="delete"
                    modalText="Modify Partial will allow you to update only empty fields only."
                    actionText="Do you want continue modifying?"
                    closeModal={() => SetisPartialModify(false)}
                    onAction={() => props.partialModify(recordData[0])}
                />
            )}

            {action == "review" && (
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to confirm the review."
                    actionText="Confrim Review?"
                    closeModal={() => props.onClose()}
                    onAction={() => sendReviewApprove("review")}
                />
            )}

            {action == "approve" && (
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to approve this? Once approved, this action cannot be undone."
                    actionText="Confrim Approve?"
                    closeModal={() => props.onClose()}
                    onAction={() => sendReviewApprove("approve")}
                />
            )}

            {action == "rreview" && (
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to revert the review."
                    actionText="Revert Review?"
                    closeModal={() => props.onClose()}
                    onAction={() => sendReviewApprove("rreview")}
                />
            )}

            {action == "rapprove" && (
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to revert approval?"
                    actionText="Revert Approval?"
                    closeModal={() => props.onClose()}
                    onAction={() => sendReviewApprove("rapprove")}
                />
            )}

            {action == "previewFileData" && (
                <ModalComponent
                    width="65%"
                    isOpen={true}
                    onClose={() => setAction("")}
                    header="Preview File Data"
                    centered={true}
                    customClass='preview-file-data-modal'
                    body={
                        <>
                            <div>
                                {previewFileData}
                            </div>
                        </>
                    }
                    footer={<></>}
                />
            )}

            <Row className='m-0'>
                <Col className='p-0'>
                    <div className='form-name'>{props.formData?.form_name}</div>
                </Col>

                <Col className='p-0 text-right'>
                    <i className='icon icon-close' onClick={() => props.onClose()} />
                </Col>
            </Row>

            {/* OCR Notification and Toggle */}
            {ocrOutput && (
                <Row className='m-0 ocr-notification'>
                    <Col className='p-0'>
                        <div className='ocr-info-container'>
                            <span className='ocr-info-text'>This form was filled using OCR</span>
                            <CustomButton
                                type="primary"
                                text={showOcrSplit ? "Hide OCR Output" : "View OCR Output"}
                                onClick={toggleOcrSplit}
                                className="ocr-toggle-btn"
                            />
                        </div>
                    </Col>
                </Row>
            )}

            {/* STT Notification and Toggle */}
            {sttOutput && sttOutput.conversation && (
                <Row className='m-0 stt-notification'>
                    <Col className='p-0'>
                        <div className='stt-info-container'>
                            <span className='stt-info-text'>This form was filled using Speech-to-Text</span>
                            <CustomButton
                                type="primary"
                                text={showSttSplit ? "Hide Conversation" : "View Conversation"}
                                onClick={toggleSttSplit}
                                className="stt-toggle-btn"
                            />
                        </div>
                    </Col>
                </Row>
            )}

            <div className={`main-content ${showOcrSplit || showSttSplit ? 'split-view' : ''}`}>
                <div className={`form-section ${showOcrSplit || showSttSplit ? 'half-width' : 'full-width'}`}>
                    {renderFormContent()}
                </div>

                {showOcrSplit && ocrOutput && (
                    <div className='ocr-section half-width'>
                        <div className='ocr-header'>
                            <h4>OCR Output</h4>
                        </div>

                        {/* OCR File Details Section */}
                        {ocrFileDetails && (
                            <div className='ocr-file-details'>
                                {ocrFileDetails.source_file_name && <div className='file-detail-item'>
                                    <span className='file-label'>Uploaded file -  </span>
                                    <span className='file-name'>&nbsp;{ocrFileDetails.source_file_name}</span>
                                    <CustomButton
                                        type="primary"
                                        text="Download File"
                                        className="download-file-btn"
                                        onClick={() => window.open(`https://go.coguide.in/c1/download/${ocrFileDetails.source_file_link}`, '_blank')}
                                    />
                                </div>}
                                {ocrFileDetails.processed_file_name && (
                                    <div className='file-detail-item'>
                                        <span className='file-label'>Processed file - </span>
                                        <span className='file-name'>&nbsp;{ocrFileDetails.processed_file_name}</span>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className='ocr-content'>
                            <ReactMarkdown>{ocrOutput}</ReactMarkdown>
                        </div>
                    </div>
                )}

                {showSttSplit && sttOutput && sttOutput.conversation && (
                    <div className='stt-section half-width'>
                        <div className='stt-header'>
                            <h4>Conversation Recording</h4>
                        </div>

                        {/* STT File Details Section */}
                        {sttFileDetails && (
                            <div className='stt-file-details'>
                                {sttFileDetails.source_file_name && (
                                    <div className='file-detail-item'>
                                        <span className='file-label'>Audio file - </span>
                                        <span className='file-name'>&nbsp;{sttFileDetails.source_file_name}</span>
                                        {sttFileDetails.source_file_link && (
                                            <CustomButton
                                                type="primary"
                                                text="Download Audio"
                                                className="download-file-btn"
                                                onClick={() => window.open(`https://go.coguide.in/c1/download/${sttFileDetails.source_file_link}`, '_blank')}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Full Transcript Section */}
                        {sttOutput.full_transcript && (
                            <div className='stt-full-transcript'>
                                <div className='stt-transcript-header'  >
                                    <h5>Full Transcript</h5>
                                    <CopyOutlined
                                        onClick={copyFullTranscript}
                                        style={{ cursor: 'pointer', fontSize: '16px', color: 'var(--primary-color, #1890ff)' }}
                                        title="Copy full transcript"
                                    />
                                </div>
                                <p className='transcript-text'>{sttOutput.full_transcript}</p>
                            </div>
                        )}

                        {/* Conversation View */}
                        {sttOutput?.conversation && sttOutput?.conversation.length > 0 && <div className='stt-content'>
                            <div className='stt-conversation-header' >
                                <h5>Conversation</h5>
                                <CopyOutlined
                                    onClick={copyConversation}
                                    style={{ cursor: 'pointer', fontSize: '16px', color: 'var(--primary-color, #1890ff)' }}
                                    title="Copy conversation"
                                />
                            </div>
                            <div className='conversation-list'>
                                {sttOutput?.conversation && sttOutput?.conversation.map((line, index) => {
                                    const [speaker, ...textParts] = line.split(':');
                                    const text = textParts.join(':').trim();

                                    return (
                                        <div key={index} className='conversation-item'>
                                            <span className='speaker-label'>{speaker}:</span>
                                            <span className='speaker-text'>{text}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>}
                    </div>
                )}
            </div>

            {
                !props.isPreview ?
                    <div className="modify-footer-form">


                        {
                            permissionData && permissionData['edit partial data record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Modify Partial"
                                    onClick={() => SetisPartialModify(true)}
                                />
                                : ""
                        }

                        {
                            permissionData && permissionData['edit record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Modify"
                                    onClick={() => setisModify(true)}
                                />
                                : ""
                        }

                        {
                            permissionData && permissionData['review data record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Confirm Review"
                                    onClick={() => setAction("review")}
                                />
                                :
                                ""
                        }

                        {
                            permissionData && permissionData['reverse review data record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Revert Review"
                                    onClick={() => setAction("rreview")}
                                />
                                :
                                ""
                        }

                        {
                            permissionData && permissionData['approve data record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Confirm Approval"
                                    onClick={() => setAction("approve")}
                                />
                                :
                                ""
                        }


                        {
                            permissionData && permissionData['reverse approval data record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Revert Approval"
                                    onClick={() => setAction("rapprove")}
                                />
                                : ""
                        }



                    </div>
                    :
                    <div className="modify-footer-form">
                        <CustomButton
                            type="primary"
                            text="Save Config"
                            onClick={() => SaveConfig()}
                        />
                    </div>
            }


        </div >
    )
}